import * as useQueryActions from "./organizations.actions";
import * as slice from "./organizations.reducers";
import * as selectors from "./organizations.selectors";

export const {
  name,
  reducer,
  actions: {
    setSelectedOrganizationId,
    setSelectedOrganization,
    setOrganizationsFilters,
    setOrganizationUsersFilters,
    setOrganizationUsersId,
  },
} = slice;

export const {
  fetchOrganizations,
  fetchOrganizationUsersById,
  deleteOrganization,
  updateOrganization,
  createOrganization,
} = useQueryActions;

export const {
  selectOrganizations,
  selectSelectedOrganizationId,
  selectOrganizationUsers,
  selectSelectedOrganization,
  selectOrganizationsFilters,
  selectOrganizationUsersFilters,
  selectOrganizationUsersId,
} = selectors;
